var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectBoxes',{attrs:{"items-name":"select_box","items":_vm.items,"default-index":2}})}
var staticRenderFns = []

export { render, staticRenderFns }